import { ModelBase, PropertyChangingJoinPointContext } from '@skylab-shared/core';
import { Constructor } from '@skylab-shared/types';

type Handler =  (ctx: PropertyChangingJoinPointContext) => void;

type HandlerWithFiltering = (ctx: PropertyChangingJoinPointContext) => void;

export const propertyChangingJoinPointFilter = (sender: any) => <TModel extends ModelBase>(type: Constructor<TModel>, properties: (keyof TModel)[]) => (handler: Handler): HandlerWithFiltering  => {
    return (ctx: PropertyChangingJoinPointContext): void => {
        if (ctx.model instanceof type && (sender == null || (sender != null && ctx.sender === sender)) && (<string[]> properties).indexOf(ctx.propertyName) > -1) {
            handler(ctx);
        }
    };
};
